import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

type ButtonProps = {
  [x: string]: any;
};

export const ActionButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return <ButtonStyle {...props}>{children}</ButtonStyle>;
};

const ButtonStyle = styled(Button)`
  display: block;
  width: 100%;
  border: 2px solid #ddd;
  color: #333;
  font-weight: 600;
`;
